import useAuthStore from "../services/AuthService";

export const logoutUser = async () => {
  const { logout } = useAuthStore.getState();
  await logout();
};
